// Exclude HubSpot from Datadog tracing to avoid CORS errors
// caused by injected tracing headers (x-datadog-origin: rum) on cross-origin HubSpot requests
export const HUBSPOT_API_HOST = 'api.hubspot.com';
